module.exports = __webpack_public_path__ + "img/ktb.247daaef.png";